export enum NOTIFICATION_STATUS {
    Changed = "Changed",
    Failed = "Failed",
    Info = "Info",
    Reminder = "Reminder",
    Succeeded = "Succeeded",
    Warning = "Warning"
}
